export function themeUnitToNativeValue(value: string): number {
    return parseInt(value, 10);
}
